import { ControlledParameter } from '../controlled-parameter';
export class TbaTransactionsPayload {
  addTransactionIds: number[];
  removeTransactionIds: number[];
  tbaControlledParameters: ControlledParameter[];
}
